module.exports = __webpack_public_path__ + "static/media/my-profile-active.b4d9da50.svg";